import Navbar from "@/components/unsf/Navbar"
import Footer from "@/components/unsf/Footer"
import { UnsfItem } from "@/components/unsf/ProductCard"
import StoreCatalog from "@/components/storefront/StoreCatalog"
import UnsfHead, { UnsfMeta } from "@/components/unsf/UnsfHead"
import type {
  UnsfNavbarProps,
  UnsfFooterProps,
} from "@/components/unsf/LegalLayout"

interface Category {
  id: number
  name: string
}

interface SortOption {
  value: string
  label: string
}

interface FilterState {
  query: string
  sort: string
  selected_categories: string[]
  min_price: number
  max_price: number
  available_max_price: number
}

interface Labels {
  return: string
  title: string
  filter: string
  no_products: string
  search_placeholder: string
  sort_label: string
  price_label: string
  min_price: string
  max_price: string
  apply: string
  reset: string
}

interface Props {
  meta: UnsfMeta
  labels: Labels
  urls: { root: string; store: string }
  categories: Category[]
  items: UnsfItem[]
  filters: FilterState
  sort_options: SortOption[]
  i18n: {
    soldout: string
    last_pieces: string
    no_image: string
    pre_sale: string
  }
  navbar: UnsfNavbarProps
  footer: UnsfFooterProps
  csrf_token: string
  cart: import("@/components/unsf/Cart").CartData
}

export default function Store({
  meta,
  labels,
  urls,
  categories,
  items,
  filters,
  sort_options,
  i18n,
  navbar,
  footer,
  csrf_token,
  cart,
}: Props) {
  const breadcrumbs = [
    { name: "UNSF Clothing", url: meta.canonical_url.replace(urls.store, urls.root) },
    { name: labels.title, url: meta.canonical_url },
  ]

  return (
    <>
      <UnsfHead meta={meta} breadcrumbs={breadcrumbs} />

      <Navbar
        isHome={false}
        logoWhite={navbar.logo_white}
        logoBlack={navbar.logo_black}
        labels={navbar.labels}
        urls={navbar.urls}
        locale={{
          current: navbar.locale.current,
          other: navbar.locale.other,
          switchUrl: navbar.locale.switch_url,
        }}
        csrfToken={csrf_token}
        cart={cart}
      />

      <StoreCatalog
        brandName="UNSF"
        labels={labels}
        urls={urls}
        categories={categories}
        items={items}
        filters={filters}
        sortOptions={sort_options}
        i18n={i18n}
      />

      <Footer
        logoWhite={footer.logo_white}
        labels={footer.labels}
        urls={footer.urls}
      />
    </>
  )
}
